import * as React from "react";
import { IDataCenter } from "../../vm";
import { IStackTokens, Stack, Text } from "office-ui-fabric-react";
import { Loading } from "../../services/Loading";
import { INFRASTRUCTURE_TYPES } from "../common/Constants";
import { Card, ICardTokens } from "@uifabric/react-cards";
import { GS } from "../../utils/Styles";
import { useHistory } from "react-router-dom";
import { parseJwt } from "../../services/UtilService";

export interface InfraStructureMainProps {
  datacenter: IDataCenter;
}

const InfraStructureMain: React.FC<InfraStructureMainProps> = ({
  datacenter,
}) => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    infraStructureList: INFRASTRUCTURE_TYPES,
  } as {
    isLoading: boolean;
    infraStructureList: Array<{
      label: string;
      value: string;
      imageUrl: any;
      width: number;
      height: number;
    }>;
  });

  //hooks
  const childrenGap24: IStackTokens = { childrenGap: 24 };
  const cardTokens: ICardTokens = { childrenMargin: 16 };
  const history = useHistory();

  React.useEffect(() => {
    const asyncFunc = async () => {
      let tokenData = parseJwt();
      if (tokenData.isAdmin === false && tokenData.role === 0) {
        let infraList: any[] = [];
        tokenData.units.forEach((ele: any) => {
          switch (ele) {
            case "air-cooled-chiller":
              ele = "cooled-chiller";
              break;
            case "ht":
              ele = "ht-panel";
              break;
            case "dg":
              ele = "dg-set";
              break;
            case "idc":
              ele = "idc-temperature";
              break;
          }

          const item = INFRASTRUCTURE_TYPES.find((e) => e.value === ele);
          if (item) {
            infraList.push(item);
          }
        });
        setState({ ...state, infraStructureList: infraList });
      }
    };
    asyncFunc();
  }, []);

  const viewInfrastructure = (
    datacenterId: string,
    infrastructureName: string
  ) => {
    history.push(
      `/datacenters/${datacenterId}/infrastructure/${infrastructureName}`
    );
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap24} className="pt-8">
        <Stack.Item>
          <div className="ms-Grid">
            <div className="ms-Grid-row">
              {state.infraStructureList.map((item, index) => (
                <div
                  className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3 ms-xxl2 infrastructure-card-alignment"
                  key={index}
                >
                  <Card
                    className="ms-motion-scaleDownIn card-width infrastructure-card"
                    horizontal
                    styles={{ root: { ...GS.bgWhite } }}
                    tokens={cardTokens}
                  >
                    <Card.Section className="m-0 padding-16" grow={1}>
                      <Stack
                        horizontal
                        horizontalAlign="space-between"
                        className="pointer cardItem"
                        styles={{ root: { width: "100%", height: "130px" } }}
                        onClick={() =>
                          viewInfrastructure(
                            datacenter._id as string,
                            item.value
                          )
                        }
                      >
                        <Stack.Item>
                          <Text className="infrastructure-card-title">
                            {item.label}
                          </Text>
                        </Stack.Item>
                        <Stack.Item align="end">
                          <img
                            src={item.imageUrl}
                            alt={item.label}
                            style={{ height: item.height, width: item.width }}
                            className="infrastructure-card-image"
                          />
                        </Stack.Item>
                      </Stack>
                    </Card.Section>
                    {/* <div className="card-bg-image">
                      <img src={CradBgImage} alt="card-bg" />
                    </div> */}
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default InfraStructureMain;
